import * as React from "react";
import type { SVGProps } from "react";
const SvgXeroSynced = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18" {...props}
  >
    <rect width={18} height={18} fill="#13B5EA" rx={4} />
    <path
      fill="#fff"
      d="M9 4C6.24 4 4 6.24 4 9s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m2 7.6c-.14.14-.32.2-.5.2s-.36-.07-.5-.2l-1-1-1 1c-.14.14-.32.2-.5.2s-.36-.07-.5-.2a.71.71 0 0 1 0-1l1-1-1-1a.71.71 0 0 1 0-1 .71.71 0 0 1 1 0l1 1 1-1a.71.71 0 0 1 1 0 .71.71 0 0 1 0 1l-1 1 1 1a.71.71 0 0 1 0 1"
    />
  </svg>
);
export default SvgXeroSynced;
